export const colors = [
  { code: "#0492C2", name: "Blue" },
  { code: "#22c55e", name: "Green" },
  { code: "#8b5cf6", name: "Purple" },
  { code: "#ef4444", name: "Red" },
  { code: "#f97316", name: "Orange" },
  { code: "#14b8a6", name: "Cyan" },
  { code: "#f472b6", name: "Pink" },
  { code: "#6b7280", name: "Gray" }
];

export const colors_dict = {
  Blue: "#0492C2",
  Green: "#22c55e",
  Purple: "#8b5cf6",
  Red: "#ef4444",
  Orange: "#f97316",
  Cyan: "#14b8a6",
  Pink: "#f472b6",
  Gray: "#6b7280"
};

export const light_colors = {
  Blue: "#d4edf6",
  Green: "#dcfce7",
  Purple: "#ede9fe",
  Red: "#fee2e2",
  Orange: "#fcdfbb",
  Cyan: "#b5ffff",
  Pink: "#fde2e9",
  Gray: "#e5e7eb"
};